<template>
  <div class="basicLayout">
    <Header class="visible-lg-block visible-md-block"/>
    <HeaderMobile class="visible-xs-block visible-sm-block"/>
    <router-view />
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/header/Header';
import HeaderMobile from '@/components/header/HeaderMobile';
import Footer from '@/components/Footer';

export default {
  name: 'BasicLayout',
  components: {
    Header,
    HeaderMobile,
    Footer
  },
  props: {
  },
};
</script>

<style scoped lang="scss">
</style>
